import React from 'react';

interface PageHeaderProps {
    title: string;
    subtitle?: string;
}

export const PageHeader: React.FC<PageHeaderProps> = ({ title, subtitle }) => {
    return (
        <div className="page-header">
            <h1 className="page-title">{title}</h1>
            {subtitle && <span className="page-subtitle">{subtitle}</span>}
        </div>
    );
};

interface SectionHeaderProps {
    title: string;
}

export const SectionHeader: React.FC<SectionHeaderProps> = ({ title }) => {
    return (
        <div className="section-header" style={{ marginTop: '40px' }}>
            <h2 className="section-title">{title}</h2>
        </div>
    );
};
